import React from 'react';
import "./PageHeader.scss";

export default function PageHeader({left, right}) {
  return(
    <div className="pageheader">
        <div className="col-sm-6 pageheader-left">
          {left}
        </div>
        <div className="col-sm-6 pageheader-right">
          {right}
        </div>
    </div>
  );
}
